var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8906 3.5625H2.10938C0.948656 3.5625 0 4.50698 0 5.67188V18.3281C0 19.4934 0.949266 20.4375 2.10938 20.4375H21.8906C23.0513 20.4375 24 19.493 24 18.3281V5.67188C24 4.5067 23.0509 3.5625 21.8906 3.5625ZM21.5667 4.96875C20.8847 5.65298 12.874 13.6898 12.5449 14.02C12.27 14.2957 11.7301 14.2959 11.4551 14.02L2.43328 4.96875H21.5667ZM1.40625 18.0696V5.93039L7.45617 12L1.40625 18.0696ZM2.43328 19.0312L8.44894 12.996L10.4592 15.0128C11.283 15.8393 12.7174 15.8389 13.5409 15.0128L15.5511 12.996L21.5667 19.0312H2.43328ZM22.5938 18.0696L16.5438 12L22.5938 5.93039V18.0696Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.8cece0aad3629b683b5bf64a0892ed5d.svg";
export { ForwardRef as ReactComponent };